//pkg-lots.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import {
  Pkg,
  PkgLot,
  PkgStockHistoryRow,
  PkgStockSummary,
  PkgUseRecord,
  RunPkgAuditRequest,
  UpdatePkgAuditRequest,
} from "../../models/pkg";

export const pkgLotsApi = {
  add: (pkg: Pkg, pkgLot: PkgLot): Promise<Pkg> =>
    apiProvider
      .post(`pkgs/${pkg.id}/lots`, {
        data: pkgLot,
      })
      .then((d: JsonDocument<Pkg>) => d.data),
  runAudit: (data: RunPkgAuditRequest): Promise<void> =>
    apiProvider.post("pkgs/audit", {
      data,
    }),

  updateAudit: (
    transactionId: number,
    data: UpdatePkgAuditRequest,
  ): Promise<void> =>
    apiProvider.put("pkgs/audit", transactionId, {
      data,
    }),
  update: (pkg: Pkg, pkgLot: PkgLot): Promise<PkgLot> =>
    apiProvider.put(`pkgs/${pkg.id}/lots`, pkgLot.id, {
      data: pkgLot,
    }),
  getAll: (pkg: Pkg): Promise<PkgLot[]> =>
    apiProvider
      .getAll(`pkgs/${pkg.id}/lots`)
      .then((d: JsonDocument<PkgLot[]>) => d.data),
  getUseRecords: (
    startDate?: string,
    endDate?: string,
  ): Promise<PkgUseRecord[]> =>
    apiProvider
      .getAll("pkgs/use-records", {
        startDate,
        endDate,
      })
      .then((d: JsonDocument<PkgUseRecord[]>) => d.data),
  getStockHistory: (): Promise<PkgStockHistoryRow[]> =>
    apiProvider
      .getAll("pkgs/stock-history")
      .then((d: JsonDocument<PkgStockHistoryRow[]>) => d.data),
  getStockSummary: (
    startDate?: string,
    endDate?: string,
  ): Promise<PkgStockSummary[]> =>
    apiProvider
      .getAll("pkgs/stock-summary", {
        startDate,
        endDate,
      })
      .then((d: JsonDocument<PkgStockSummary[]>) => d.data),
  trash: (pkg: Pkg, pkgLot: PkgLot): Promise<any> =>
    apiProvider.remove(`pkgs/${pkg.id}/lots`, pkgLot.id),
};
